import React, { useState, useEffect } from 'react';
import { addYears, parseISO, formatISO, isSameDay } from 'date-fns';
import { Modal, Box } from '@mui/material';

// Styles for the date range picker
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRange } from 'react-date-range';

import './date-range-selector.styles.scss';

import Accordion from '../../accordion/accordion.component';
import Button from '../../button/button.component';

const defaultProps = {
  value: ['2024-01-01','2024-12-31'],
  title: null,
  today: new Date(),
  label: () => 'Season Dates',
  rangeColor: 'rgb(0,0,139)'
};

export default function DateRangeSelector({
  expanded,
  handleChange,
  handleChangeSelection,
  id,
  value=defaultProps.value,
  title=defaultProps.title,
  today=defaultProps.today,
  label=defaultProps.label,
  rangeColor=defaultProps.rangeColor,
}) {
  const [openModal, setOpenModal] = useState(true);
  const [shownValues, setShownValues] = useState([{
    startDate: null,
    endDate: null,
    key: 'selection',
    color: rangeColor
  }]);

  useEffect(() => {
    setShownValues([{
      ...shownValues[0],
      startDate: parseISO(value[0]),
      endDate: parseISO(value[1])
    }]);
  }, [value]);

  const handleClose = (doUpdate) => {
    if (doUpdate) {
      handleChangeSelection([formatISO(shownValues[0].startDate).slice(0,10), formatISO(shownValues[0].endDate).slice(0,10)]);
    }
    setOpenModal(false);
  };

  const handleAccordionClick = (panel) => (event, id) => {
    setOpenModal(true);
    handleChange(panel)(event,id);
  }

  const canSubmit = !(isSameDay(parseISO(value[0],shownValues[0].startDate)) && isSameDay(parseISO(value[1],shownValues[0].endDate)));

  return (
    <React.Fragment>
      <Accordion expanded={false} handleChange={handleAccordionClick} id={id} label={label()}></Accordion>
      <Modal
        open={expanded === id && openModal}
        onClose={() => handleClose(canSubmit)}
      >
        <Box className='date-range-modal-container'>
          {title ? <h4>{title}</h4> : ''}

          <DateRange
            editableDateInputs={true}
            onChange={item => setShownValues([{ ...shownValues[0], ...item.selection }])}
            moveRangeOnFirstSelection={false}
            ranges={shownValues}
            months={2}
            minDate={new Date(1952,0,1)}
            maxDate={addYears(today, 1)}
          />

          <div className='date-range-btns-container'>
            <Button
              buttonType={canSubmit ? 'small' : 'disabled'}
              onClick={() => handleClose(canSubmit)}
              disabled={!canSubmit}
              style={{
                margin: '0'
              }}
            >Submit</Button>
          </div>
        </Box>
      </Modal>
    </React.Fragment>
  );
}

export { defaultProps };